module.exports = "../../../../platform/assets/pageMainIcon/baobiaochaxunlei7.svg";